<template>
	<div class="Passenger_box" v-show="img_class_box">
		<div class="class_Passenger" @click="huanxin_customer_service" @mouseenter="mouseenter()" @mouseleave="mouseleave()">
			<div id="img_class">
				<img src="https://s3-us.tozostore.com/testTozo/cms/202211251719333cd70577ae422b560416b2dec1b43393.png" alt="TOZO customer service"/>
			</div>
		</div>
	</div>
</template>
<script>

export default {
  name: 'PassengerPc',
  components: {},
  data() {
    return {
      class_Passenger: true,
      img_class_box:false
    }
  },
  watch: {
    img_class_box: {
      handler: function(val, oldval) {
        if(val){
          this.mouseleave()
        }
      }
    },
  },
  mounted() {
    setTimeout(()=>{
      this.img_class_box = true
    },3000)
  },
  methods:{
    mouseenter(){
      let img_class = document.getElementById('img_class')
      let img = img_class.getElementsByTagName("img")[0]
      img.style.transition = '0.4s'
      img.style.transform = 'scale(5)'
    },
    mouseleave(){
      let img_class = document.getElementById('img_class')
      let img = img_class.getElementsByTagName("img")[0]
      img.style.transition = '0.4s'
      img.style.transform = 'scale(0)'
    },
    huanxin_customer_service(){
      // let that = this
      // that.mouseenter()
      // setTimeout(() => {that.mouseleave()}, 600)
      if(!this.class_Passenger){ return }
      else{
        let that = this
        window.easemobim = window.easemobim || {};
        easemobim.config = {
          hide: true,
          autoConnect: false,
          configId: '5c8b614f-8d90-4060-88f1-673d508301d5',
          //打开
          onopen: function () {that.class_Passenger = false},
          //收起
          onclose: function () {that.class_Passenger = true },
          // visitor: {
          //   trueName: '112222',//值外层必须要有单引号以字符串格式传输否则传输失败
          //   userNickname: '1234',
          //   description: '0909',
          //   email: '',
          //   userDefineColumn: '{"WQQ":"帅哥","QAZ":"LLLLLLLTTTTTTTT"}',
          // }
        }
        easemobim.bind({configId: "5c8b614f-8d90-4060-88f1-673d508301d5"})
      }
    },
  }
}
</script>
<style lang='less' scoped>
	.class_Passenger{
	   cursor:pointer;
	   color: #ffffff;
	   background: url('https://s3-us.tozostore.com/testTozo/cms/20230703121514ac4427fc9157836d956f2a8dbc52e604.webp');
	   background-size: 100%;
	   background-repeat:no-repeat;
	   box-shadow: rgba(2, 6, 16, 0.2) 0px 2px 16px;
	   position: fixed;
	   bottom: 80px;
	   right: 0;
	   z-index: 999999999999999999;
	   margin-right: 10px;
	   border-radius: 50%;
	   display: flex;
	   justify-content: center;
	   align-items: center;
	   transition: bottom .3s;
	}
	#img_class{
	   border-radius: 50%;
	   display: flex;
	   justify-content: center;
	   align-items: center;
	}
	#img_class>img{
	   width: 10px;
	   height: 10px;
	   transform: scale(0);
	   cursor: pointer;
	   border-radius: 50%;
	}
	.class_Passenger:hover{
	   /* opacity: 0.5; */
	}
	@media only screen and (min-width: 1024px) {
	   .class_Passenger{
	      width: 50px;
	      height: 50px;
	   }
	   #img_class{
	      width: 50px;
	      height: 50px;
	   }
	}
	@media only screen and (min-width: 768px) and (max-width: 1024px){
	   .class_Passenger{
	      width: 50px;
	      height: 50px;
	      margin-right: 20px;
	   }
	   #img_class{
	      width: 50px;
	      height: 50px;
	   }
	}
	@media only screen and (max-width: 768px) {
	   .class_Passenger{
	      width: 50px;
	      height: 50px;
	   }
	   #img_class{
	      width: 50px;
	      height: 50px;
	   }
	}
	@media only screen and (min-width: 600px) and (max-width: 768px){
	   .class_Passenger{
	      margin-right: 15px;
	   }
	}
	@media only screen and (max-width: 600px) {
	   .class_Passenger{
	      margin-right: 10px;
	   }
	}
</style>
